import { gql } from 'apollo-boost';

export const ENROLL_ACTIVATION_EMAIL_SEQUENCE = gql`
    mutation($data: EnrollActivationEmailSequenceInput!) {
        enrollActivationEmailSequence(data: $data) {
            ... on EnrollActivationEmailSequenceSuccess {
                enrolledCount
                skippedCount
                message
            }
            ... on InternalServerError {
                message
            }
        }
    }
`;
